import { Watchable } from "./Watchable"

export const createWatchable = <T extends object>(obj: T) => {
  return new Watchable(obj)
}
